import "../suppressConsole";

import React from "react";
import ReactDOM from "react-dom";

import { EntryPoint } from "./EntryPoint";

import "css/entrypoint.scss";

const root = document.createElement("div");
root.id = "react-root";
root.style.display = "contents";
document.body.appendChild(root);

ReactDOM.render(
    <EntryPoint />,
    root
);
